(function() {
  'use strict';

  function getProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    return m ? m[1].toLowerCase() : '';
  }

  function shopifySize(u, w) {
    if (!u) return '';
    return u.replace(/(\.(?:jpg|jpeg|png|webp))(\?.*)?$/i, '_' + w + 'x$1$2');
  }

  function findStoryImg() {
    // Prefer the story section img specifically
    var candidates = [
      '[id*="story_section"] picture img',
      '[id*="story_section"] img',
      '.shopify-section[id*="story_section"] img'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    return null;
  }

  function swapStoryImage() {
    if (!/^\/products\//.test(window.location.pathname)) return;
    var imgEl = findStoryImg();
    if (!imgEl || imgEl.dataset.dmkSwapped === '1') return;
    var handle = getProductHandle();
    if (!handle) return;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(p) {
        var images = (p.images && p.images.length) ? p.images : [];
        if (!images.length) return;

        // Pick a non-primary detail/closeup image for editorial feel.
        // If 3+ images: use the LAST image. If 2: use 2nd. If 1: use it.
        var picked;
        if (images.length >= 3) picked = images[images.length - 1];
        else if (images.length === 2) picked = images[1];
        else picked = images[0];

        if (!picked) return;
        var url = picked.indexOf('//') === 0 ? 'https:' + picked : picked;

        imgEl.src = shopifySize(url, 1200);
        imgEl.srcset = shopifySize(url, 480) + ' 480w, '
                     + shopifySize(url, 800) + ' 800w, '
                     + shopifySize(url, 1200) + ' 1200w, '
                     + shopifySize(url, 1600) + ' 1600w';
        imgEl.alt = p.title ? p.title + ' — hand-knit detail' : 'Hand-knit detail';
        imgEl.removeAttribute('width');
        imgEl.removeAttribute('height');
        imgEl.style.width = '100%';
        imgEl.style.height = '100%';
        imgEl.style.objectFit = 'cover';
        imgEl.dataset.dmkSwapped = '1';
      })
      .catch(function() {});
  }

  function init() {
    swapStoryImage();
    // Retry once after a beat in case story section mounted late
    setTimeout(swapStoryImage, 800);
    setTimeout(swapStoryImage, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
